<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">

    <div class="md-layout-item md-elevation-0">
      <div v-for="(value, i) in form" :key="i" :set="v = $v.form.$each[i]">

      <md-card class="md-elevation-0 m-5" :class="getValidationClass(i, 'nombres')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Información Mancomuno {{i + 1}}
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Apellido(s) y Nombre(s) del Mancomuno *
            </p>
            <div>            

              <md-field :class="getValidationClass(i, 'nombres')">
                <md-input type="text" id="nombres" name="nombres" placeholder="Su respuesta" v-model="value.nombres" autocomplete="off" />
                <span class="md-error" v-if="!v.nombres.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!v.nombres.minLength">Formato inválido</span>
                <span class="md-error" v-else-if="!v.nombres.alpha">Formato inválido</span>
              </md-field>            

            </div>
          </md-card-content> 
      </md-card>            
 
      <md-card class="md-elevation-0 m-5" :class="getValidationClass(i, 'docIdentidad')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Documento de identidad *
        </md-card-header>
        <md-card-content>
            <div>
              <md-checkbox v-model="value.docIdentidad" value="DNI">DNI</md-checkbox>
              <md-checkbox v-model="value.docIdentidad" value="CE">Carné Extranjería</md-checkbox>
              <md-checkbox v-model="value.docIdentidad" value="PAS">Pasaporte</md-checkbox>
            </div>

            <div class="radioform" :class="getValidationClass(i, 'docIdentidad')">
              <span class="md-error" v-if="!v.docIdentidad.required">Esta respuesta es obligatoria.</span>
            </div>            

        </md-card-content> 
      </md-card>     

      <md-card class="md-elevation-0 m-5" :class="getValidationClass(i, 'nrodocIdentidad')" >
        <md-card-header class="md-layout md-alignment-center-left justify">
          Número de documento de identidad *
        </md-card-header>
        <md-card-content>

          <div>

            <md-field :class="getValidationClass(i, 'nrodocIdentidad')">
              <md-input type="text" id="nrodocIdentidad" name="nrodocIdentidad" placeholder="Su respuesta" v-model="value.nrodocIdentidad" autocomplete="off" />
              <span class="md-error" v-if="!v.nrodocIdentidad.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.nrodocIdentidad.valDoc">Formato inválido</span>
              <span class="md-error" v-else-if="!$v.form.nrodocIdentidad.minLength">Formato inválido</span>
            </md-field>

          </div>
        </md-card-content> 
      </md-card> 


      </div>
                    

      <div>
        <md-button class="md-raised" @click="back">Atras</md-button>  
        <md-button class="md-raised" type="submit">Siguiente</md-button>  
      </div>    

    </div>

  </form>
</template>

<style>

</style>

<script>

import { validationMixin } from 'vuelidate'
import { alpha, valDoc } from '../variables'
import {
  required,
  minLength,
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Form21',
  data: () => ({
    nroform: null,
    form:[]
  }),
  mounted: function(){
    this.form = this.$store.state.form.form21
    var token = parseInt(this.$route.params.token)
    if(!isNaN(token)){
      if(token < 10){
        this.nroform = token
      }else{
        this.nroform = 1
      }
    }else{
      this.nroform = 1
    }
    this.form = [...Array(this.nroform).keys()].map(i => this.form[i] || {});

  }, 
  validations: {
    form: {
        $each:{
            nombres: { required, minLength: minLength(3),alpha},
            docIdentidad: { required, minLength: minLength(3)},
            nrodocIdentidad: { required, valDoc, minLength: minLength(3)},
        }
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form21
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('setSaveForm', {id:"21", form: this.form, index: "22"}); 
      }

    },
    getValidationClass (i,fieldName) {
      const field = this.$v.form.$each[i][fieldName]
      //console.log("%s, %s",fieldName,field)
       if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },        
  }, 

}
</script>
